import script from "./radio.vue?vue&type=script&lang=jsx"
export * from "./radio.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__